import {
    SET_PURCHASERECONCILIATION,
    SET_CHANGESTATE_LIST_TYPE_STATE
} from "@/views/purchase_reconciliation/store/types/types.js";

const mutations = {
    [SET_PURCHASERECONCILIATION]: (state, payload) => state.purchaseReconciliation = payload,
    [SET_CHANGESTATE_LIST_TYPE_STATE]: (state, payload) => state.typeChangeState = payload,
};

export default mutations